import { useLocation } from "react-router-dom";
import { SessionEndedState } from "@/components/shell/session-ended-state";
import { safeReturnPath } from "@/lib/session-expiry";

/**
 * `/session-expired` (ALL-5718): the same session-ended state the shell shows
 * when an API call finds the session gone, reachable directly. It used to show
 * fixture times ("Last active 10:15 UTC") that were never true; it now shows
 * only the fixed copy and sends the person to sign-in with the validated
 * `return_to` from its own query.
 */
export default function SessionExpiredPage() {
  const location = useLocation();
  const returnTo = safeReturnPath(new URLSearchParams(location.search).get("return_to"));
  return <SessionEndedState returnTo={returnTo} autoRedirect />;
}
